export default "__VITE_ASSET__B2PJUtDM__"